export default __webpack_public_path__ + "static/media/blog_inner_10.c266a635.png";